import { common as enCommon } from './en/common';
import { common as csCommon } from './cs/common';

export default {
  en: {
    translation: enCommon
  },
  cs: {
    translation: csCommon
  }
};